import { ChangeDetectionStrategy, Output, EventEmitter, Component, Input, ViewEncapsulation } from '@angular/core';
import { ICommentModel } from '@fi-app/shared/models';
import { ObjectTypes } from '@fi-shared/types';
import { FiAttachmentDisplaySize } from '@fi-shared/types';
@Component({
    selector: 'fi-comment-content',
    templateUrl: './fi-comment-content.component.html',
    styleUrls: ['./fi-comment-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-comment-content' },
    standalone: false,
})
export class FiCommentContentComponent {
    @Input({ required: true }) comment: ICommentModel;
    @Input({ required: true }) showEditor: boolean;
    @Input({ required: true }) isDisabled: boolean;
    @Input({ required: true }) commentCopyForEdit: ICommentModel;
    @Input({ required: true }) objectId: number;
    @Input({ required: true }) objectType: ObjectTypes;
    @Input({ required: true }) instanceId: string;
    @Input() isAttachmentsListHidden: boolean = false;
    @Input() attachmentsDisplaySize: FiAttachmentDisplaySize = FiAttachmentDisplaySize.Medium;

    protected readonly FiAttachmentDisplaySize = FiAttachmentDisplaySize;

    @Output() onCloseEditor = new EventEmitter<void>();

    protected closeEditor(): void {
        this.onCloseEditor.emit();
    }

    protected isAttachmentsListShown(): boolean {
        return (
            !this.isAttachmentsListHidden &&
            (!!this.comment.MediaBankFileReferences?.length || !!this.comment.Links?.length)
        );
    }
}
